import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { createProgram } from "../services/goHireService";
import { CreateProgramFormData } from "../../types/service.type";

export const useCreateProgram = (onSuccess?: (data: any) => void, onError?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateProgramFormData) => createProgram(payload),
    mutationKey: GO_SERVICE_QUERY_KEYS.services(),

    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.services() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.trendingServices() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.topServiceProviders() });
      onSuccess?.(data);
    },
    onError: () => {
      onError?.();
    },
  });
};
